<template>
  <div class="hello container">
    <div class="container mt-3">
      <h3>Listas de correos</h3>
      <div class="row">
        <h5>
          Enviar mensaje a:
          {{ listaSeleccionada.nombre }}
        </h5>
        <div class="col-12 col-sm-6 mx-auto">
          <select class="custom-select" @change="seleccionarLista($event)">
          <option selected>Seleccionar lista</option>
          <option
            v-for="cat in listas"
            v-bind:key="cat.id"
            v-bind:value="cat.id"
          >
            {{ cat.nombre }}
          </option>
        </select>
        </div>  
        
      </div>
      <div class="row mt-4">
        <div class="col-12 col-sm-6 mx-auto">
          <!-- <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Asunto"
              aria-label="Ingrese aquí"
              aria-describedby="basic-addon1"
              maxlength="40"
              v-model="mensaje.asunto"
              
            />
          </div> -->

          <!-- Asunto -->
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Asunto"
              aria-label="Ingrese aquí"
              aria-describedby="basic-addon1"
              maxlength="40"
              v-model="mensaje.asunto"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 mx-auto">
          <!-- <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Cuerpo del mensaje"
              aria-label="Ingrese aquí"
              aria-describedby="basic-addon1"              
              v-model="mensaje.cuerpo"
            />
          </div> -->

          <!-- mensaje -->
          <div class="input-group mb-3">
            <textarea
              v-model="mensaje.cuerpo"
              class="form-control"
              placeholder="Mensaje a enviar"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="row boton">
        <!-- btn Guardar -->
        <div class="col-12 col-sm-6 mx-auto">
          <button class="btn btn-success" @click="enviarMensaje(mensaje)">
            Enviar
          </button>
        </div>
        <!-- btn Guardar -->
        <div class="col-12 col-sm-6 mx-auto">
          <button class="btn btn-success" @click="cancelar()">Cancelar</button>
        </div>
      </div>
    </div>

    <div class="container mt-4">
      <h3>Listas guardadas</h3>
      <table class="table table-hover">
        <thead>
          <tr>
            <th v-for="col in columnas" v-bind:key="col" scope="col">
              {{ col }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="lista in listas" v-bind:key="lista.id">
            <td>{{ lista.nombre }}</td>
            <td>{{ lista.campo }}</td>
            <!-- <td> -->
            <!-- <button
                type="button"
                class="btn btn-danger"
                @click="seleccionarLista(lista)"
              >
                ACA VA UN CHECK
                <font-awesome-icon :icon="Icons.EDITAR" />
              </button>
               -->
            <!-- <input type="checkbox" id="checkbox" v-model="checked" /> -->
            <!-- <input
                type="radio"
                id="checkbox"
                @click="seleccionarLista(lista)"
              /> -->
            <!-- </td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";

import { environment } from "../../environments/environment";
import { Icons as IconConstants } from "../../constants";

export default {
  // components: { FontAwesomeIcon },
  computed: {
    cestoBasura() {
      return faTrash;
    },
    Icons() {
      return IconConstants;
    },
  },
  data() {
    return {
      columnas: ["Nombre", "Campo de agrupación"],

      listas: [],
      token: "",
      lista: "",
      mensaje: {},
      listaSeleccionada: {},
      hayListaSeleccionada: false,
      checked: false,
      mensajeLista: {},
    };
  },
  methods: {
    seleccionarLista(event) {
      console.log(event.target.value);
      this.hayListaSeleccionada = true;
      this.listaSeleccionada = event.target.value;
    },
    cancelar() {
      this.listaSeleccionada = {};
      this.hayListaSeleccionada = false;
      this.mensaje = {};
      axios.get(environment.API_URL + "listacorreo").then((response) => {
        this.listas = response.data;
      });
    },
    enviarMensaje(mensaje) {
      if (mensaje.asunto && mensaje.cuerpo && this.listaSeleccionada) {
        this.mensajeLista.asunto = mensaje.asunto;
        this.mensajeLista.cuerpo = mensaje.cuerpo;
        this.mensajeLista.idlista = this.listaSeleccionada;

        axios
          .post(environment.API_URL + "listacorreo/enviar", this.mensajeLista)
          .then(() => {
            this.listaSeleccionada = {};
            this.hayListaSeleccionada = false;
            this.mensaje = {};
            Swal.fire({
              icon: "success",
              title: "Ok",
              text: "Se comenzó a enviar los correos correspondientes!",
            });
          });
      } else {
        Swal.fire({
          icon: "error",
          title: "Problemas",
          text: "Todos los campos son obligatorios",
        });
      }
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");
    axios.get(environment.API_URL + "listacorreo").then((response) => {
      this.listas = response.data;
    });
  },
};
</script>

<style scoped>
.boton {
  display: inline-flex;
  margin: 0;
  padding: 0;
}

.boton div button {
  width: 150px;
}

/* ************************************************************************ */
/* ******************* Media Queries ************************************** */
/* ************************************************************************ */

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .boton div button {
    display: inline;
    margin: 10px 0 10px 0;
    padding: 10px 0 10px 0;
  }
}
</style>
